<!-- 
  © 2025 Ananda Kumar. All rights reserved.
  Unauthorized copying of this file, via any medium, is strictly prohibited.
  Part of the Kinvyt.com Angular application.
-->
<footer class="bg-footer text-center py-3 mt-auto no-user-select">
  <div class="container">
    <p class="mb-1">
      &copy; {{ currentYear }} | <span class="com"> Kinvyt </span> |
      <a href="https://www.kinvyt.com" target="_blank" class="d-text com">Know More<i
          class="bi bi-box-arrow-up-right ms-1"></i></a> | <a routerLink="/privacy-policy" class="d-text com">Privacy
        Policy</a>
    </p>
    <p class="mb-1" *ngIf="footerText">
      Made with ❤️ for {{ footerText }}
    </p>
  </div>
</footer>